import { brandStats } from "@/mocks/hotData";

const principles = [
  { icon: "ri-time-line", title: "实时优先", text: "榜单随讨论热度实时刷新，减少信息差与滞后。" },
  { icon: "ri-eye-off-line", title: "客观呈现", text: "只反映公开热度排行，不预设立场、不夸大解读。" },
  { icon: "ri-shield-check-line", title: "来源清晰", text: "尽量保留原始语境与出处，帮助读者判断信息可信度。" },
  { icon: "ri-leaf-line", title: "理性吃瓜", text: "不做未经证实的推测，引导健康、克制的围观方式。" },
];

const feedback = [
  {
    name: "阿茶",
    role: "吃瓜老用户",
    text: "以前蹲好几个群聊手动翻热搜，现在打开吃瓜热门一页就看全，还能按时间切新鲜瓜，省心太多了。",
  },
  {
    name: "Lin",
    role: "通勤上班族",
    text: "早上挤地铁刷新两分钟就锁定今天该聊的话题，跟同事不脱节，更新确实够快。",
  },
  {
    name: "大熊",
    role: "数码爱好者",
    text: "科技热闻这条做得很细，事件排行能看到来龙去脉，比纯标题党有营养，点赞。",
  },
];

export default function AboutSection() {
  return (
    <section id="about" className="mx-auto max-w-[1200px] scroll-mt-24 px-4 py-16 md:px-6 md:py-20">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-2">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-background-100 px-3 py-1 text-xs font-medium text-foreground-700">
            <i className="ri-quill-pen-line text-accent-600"></i>
            关于吃瓜热门
          </span>
          <h2 className="mt-4 font-heading text-2xl font-black leading-snug text-foreground-950 md:text-3xl">
            让每一颗网上热瓜，<br className="hidden md:block" />
            都能被<span className="text-primary-600">及时、理性</span>地吃到
          </h2>
          <p className="mt-5 text-sm leading-relaxed text-foreground-600 md:text-base">
            吃瓜热门是一款面向中文互联网用户的实时热点聚合工具。我们把分散在各个平台的搜索热词、热门事件与社交讨论集中归一，做成清晰的热搜榜、事件排行与分类热榜。
          </p>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            我们相信"吃瓜"是一种观察世界的方式。热点背后有情绪、有争议，也有值得被理解的公共话题。因此除了及时，我们同样重视客观与克制，只呈现真实可见的热度，不做情绪煽动。
          </p>

          <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-4">
            {brandStats.map((s) => (
              <div key={s.label} className="rounded-2xl border border-background-200 bg-background-50 p-4 text-center">
                <p className="font-heading text-xl font-black text-primary-600 md:text-2xl">{s.value}</p>
                <p className="mt-1 text-xs text-foreground-500">{s.label}</p>
              </div>
            ))}
          </div>

          <div className="mt-8 flex flex-wrap gap-2.5">
            <a
              href="mailto:hello@chiguahot.example"
              className="whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-mail-line mr-1"></i>
              联系我们
            </a>
            <a
              href="#faq"
              className="whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300"
            >
              阅读内容原则
            </a>
          </div>
        </div>

        <div className="flex flex-col gap-5">
          <div className="rounded-3xl border border-background-200 bg-background-50 p-6 md:p-7">
            <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                <i className="ri-flag-2-line text-lg"></i>
              </span>
              我们的内容原则
            </h3>
            <div className="mt-5 grid grid-cols-1 gap-3 sm:grid-cols-2">
              {principles.map((p) => (
                <div key={p.title} className="flex items-start gap-3 rounded-2xl bg-background-100/70 p-4">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-background-50 text-primary-600">
                    <i className={`${p.icon} text-lg`}></i>
                  </span>
                  <div>
                    <h4 className="text-sm font-bold text-foreground-900">{p.title}</h4>
                    <p className="mt-1 text-xs leading-relaxed text-foreground-600">{p.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="rounded-3xl border border-accent-200 bg-accent-50 p-6 md:p-7">
            <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-accent-500 text-background-50">
                <i className="ri-double-quotes-l text-lg"></i>
              </span>
              他们怎么说
            </h3>
            <div className="mt-5 flex flex-col gap-4">
              {feedback.map((f) => (
                <figure key={f.name} className="rounded-2xl border border-accent-100 bg-background-50 p-4">
                  <p className="text-sm leading-relaxed text-foreground-700">"{f.text}"</p>
                  <figcaption className="mt-3 flex items-center gap-2 text-xs">
                    <span className="flex h-7 w-7 items-center justify-center rounded-full bg-primary-500 text-background-50">
                      <i className="ri-user-line"></i>
                    </span>
                    <span className="font-semibold text-foreground-900">{f.name}</span>
                    <span className="text-foreground-400">· {f.role}</span>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}